import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import trLogo from "@/assets/locales/tr.svg";
import enLogo from "@/assets/locales/en.svg";
import { CollapseIcon } from "@/icons";
import "./index.scss";
const LanguageSelector: React.FC = () => {
  const [languageSelectorIsOpen, setLanguageSelectorIsOpen] =
    useState<boolean>(false);
  const { t, i18n } = useTranslation("translation", { keyPrefix: "languages" });

  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const changeLanguage = (lang: string): void => {
    i18n.changeLanguage(lang);
  };

  const handleClickOutside = (event: MouseEvent): void => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setLanguageSelectorIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="language-selector" ref={dropdownRef}>
      <button
        className="language-button"
        onClick={() => setLanguageSelectorIsOpen((prevState) => !prevState)}
      >
        <img
          src={i18n.language === "tr" ? trLogo : enLogo}
          width={20}
          alt="language-icon"
        />
        <span className="language-label">
          {i18n.language === "tr" ? t("turkish") : t("english")}
        </span>
        <CollapseIcon
          className={`dropdown-icon ${languageSelectorIsOpen ? "open" : ""}`}
        />
      </button>

      {languageSelectorIsOpen && (
        <div className="language-list">
          <div
            className={`language-item ${
              i18n.language === "tr" ? "active" : ""
            }`}
            onClick={() => {
              changeLanguage("tr");
              setLanguageSelectorIsOpen(false);
            }}
          >
            <img src={trLogo} width={20} alt="turkish-icon" />
            {t("turkish")}
          </div>
          <div
            className={`language-item ${
              i18n.language === "en" ? "active" : ""
            }`}
            onClick={() => {
              changeLanguage("en");
              setLanguageSelectorIsOpen(false);
            }}
          >
            <img src={enLogo} width={20} alt="english-icon" />
            {t("english")}
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
